import React, { Component } from 'react';
import { Table, Select, Button, Input, InputNumber, Popconfirm, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';

const { Option } = Select;

class EditAreaCell extends Component {
    handleClick = (current) => {
        this.props.onChange({ current });
    }

    handleSelectChange = (value) => {
        const { areaList } = this.props;
        const option = areaList.find(i => i.investigationAreaId == value);
        const { investigationAreaId, investigationAreaName } = option || {};
        this.props.onChange({
            investigationAreaName,
            adeptedDomainId: investigationAreaId,
            diseaseName: '',
            diseaseRemark: '',
            adeptedDiseaseId: undefined,
        });
    }

    render() {
        const { record: { current, adeptedDomainId, investigationAreaName }, areaList } = this.props;
        const areaOption = areaList.map(d => <Option key={String(d.investigationAreaId)}>{d.investigationAreaName}</Option>);
        return (
            <div>
                {
                    current === 'investigationArea' ?
                        <Select
                            style={{ width: 100 }}
                            onChange={(value) => this.handleSelectChange(value)}
                            value={adeptedDomainId ? String(adeptedDomainId) : undefined}
                            placeholder="请选择"
                        >
                            {areaOption}
                        </Select>
                    :
                        <div style={{ minHeight: 20, width: 100, cursor: 'pointer' }} onClick={() => this.handleClick('investigationArea')}>{investigationAreaName}</div>
                }
            </div>
        );
    }
}

class EditDiseaseCell extends Component {
    state = {
        diseaseList: [],
    }

    loadDiseaseList = investigationAreaId => {
        dictCache.getDict(`DISEASE_AREA_${investigationAreaId}`, cb => {
            $.sendRequest({
                method: 'POST',
                url: `${API_URL.common.queryAllDisease}`,
                data: { investigationAreaId },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ diseaseList: res.data });
        });
    }

    handleClick = (current) => {
        this.props.onChange({ current });
        const { record: { adeptedDomainId } } = this.props;
        if (adeptedDomainId) {
            this.loadDiseaseList(adeptedDomainId);
        }
    }

    handleFocus = () => {
        const { record: { adeptedDomainId } } = this.props;
        if (adeptedDomainId) {
            this.loadDiseaseList(adeptedDomainId);
        } else {
            message.warning('请先选择擅长领域');
        }
    }

    handleSelectChange = (value) => {
        const { diseaseList } = this.state;
        const option = diseaseList.find(i => i.diseaseId == value);
        const { diseaseId, diseaseName } = option || {};
        this.props.onChange({
            diseaseName,
            diseaseRemark: '',
            adeptedDiseaseId: diseaseId,
        });
    }

    handleInputChange = (e) => {
        this.props.onChange({ diseaseRemark: e.target.value });
    }

    render() {
        const { diseaseList } = this.state;
        const { record: { current, adeptedDiseaseId, diseaseName, diseaseRemark } } = this.props;
        const diseaseOption = diseaseList.map(d => <Option key={String(d.diseaseId)}>{d.diseaseName}</Option>);
        return (
            <div>
                {
                    current === 'disease' ?
                        <div>
                            <Select
                                style={{ width: 140 }}
                                onFocus={() => this.handleFocus('disease')}
                                onChange={(value) => this.handleSelectChange(value)}
                                value={adeptedDiseaseId ? String(adeptedDiseaseId) : undefined}
                                placeholder="请选择"
                            >
                                {diseaseOption}
                            </Select>
                            {
                                diseaseName === '其他' &&
                                <Input
                                    maxLength="200"
                                    placeholder='补充其他说明'
                                    value={diseaseRemark}
                                    onChange={e => this.handleInputChange(e)}
                                    style={{ width: 140, marginTop: 4 }}
                                />
                            }
                        </div>
                    :
                        <div style={{ minHeight: 20, minWidth: 100, cursor: 'pointer' }} onClick={() => this.handleClick('disease')}>{diseaseName}{diseaseRemark ? `(${diseaseRemark})` : ''}</div>
                }
            </div>
        );
    }
}

class EditCell extends Component {
    handleClick = (current) => {
        this.props.onChange({ current });
    }

    handleSelectChange = (value) => {
        this.props.onChange({
            outPatientNum: value,
        });
    }

    render() {
        const { record: { current, outPatientNum } } = this.props;
        return (
            <div>
                {
                    current === 'outPatientNum' ?
                        <InputNumber
                            placeholder='请输入'
                            min={0}
                            precision={0}
                            style={{ width: '100%' }}
                            value={outPatientNum}
                            onChange={value => this.handleSelectChange(value)}
                        />
                    :
                        <div style={{ minHeight: 20, width: 100, cursor: 'pointer' }} onClick={() => this.handleClick('outPatientNum')}>{outPatientNum}</div>
                }
            </div>
        );
    }
}

class GoodAtAreaTable extends Component {
    state = {
        areaList: [],
    }
    
    componentDidMount() {
        this.loadAreaList();
    }

    loadAreaList = () => {
        dictCache.getDict('AREA_ALL', cb => {
            $.sendRequest({
                method: 'POST',
                url: `${API_URL.common.queryAllInvestigationArea}`,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ areaList: res.data });
        });
    }

    handleAdd = () => {
        const { count, list } = this.props;
        const newData = {
            index: count,
        };
        list.forEach(i => i.current = '');
        this.props.onChange({
            list: [...list, newData],
            count: count + 1,
        });
    }
    
    cancel = (index) => {
        const newData = [...this.props.list];
        const idx = newData.findIndex(i => i.index == index);
        if (idx || idx === 0) {
            newData.splice(idx, 1);
            this.props.onChange({ list: newData });
        }
    }

    handleChange = (index, value) => {
        const newData = [...this.props.list];
        const idx = newData.findIndex(i => i.index == index);
        newData.forEach((item, index) => (index !== idx) && (item.current = ''));
        if (idx || idx === 0) {
            const entries = Object.entries(value || {});
            entries.forEach(entry => {
                newData[idx][entry[0]] = entry[1];
            });
            this.props.onChange({ list: newData });
        }
    }

    getColumns = () => {
        const { areaList } = this.state;
        const columns = [{
            title: '擅长领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 120,
            render: (text, record) => {
                const { index } = record;
                return (
                    <EditAreaCell record={record} areaList={areaList} onChange={(value) => this.handleChange(index, value)} />
                )
            }
        }, {
            title: '擅长疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 160,
            render: (text, record) => {
                const { index } = record;
                return (
                    <EditDiseaseCell record={record} onChange={(value) => this.handleChange(index, value)} />
                )
            }
        }, {
            title: '月门诊量(人次)',
            dataIndex: 'outPatientNum',
            key: 'outPatientNum',
            render: (text, record) => {
                const { index } = record;
                return (
                    <EditCell record={record} onChange={(value) => this.handleChange(index, value)} />
                )
            }
        }, {
            title: '操作',
            key: 'operation',
            width: 80,
            render: (text, record) => {
                const { index } = record;
                return (
                    <Popconfirm title="确定要删除该行数据?" onConfirm={() => this.cancel(index)}>
                        <a>删除</a>
                    </Popconfirm>
                )
            },
        }];
        return columns;
    }

    render() {
        const { list } = this.props;
        return (
            <div style={{ marginBottom: 10 }}>
                <Button onClick={this.handleAdd} style={{ marginBottom: 10 }}>添加行</Button>
                <Table
                    bordered
                    pagination={false}
                    dataSource={list}
                    columns={this.getColumns()}
                    rowKey={record => record.index}
                />
            </div>
        );
    }
}

export default GoodAtAreaTable;


// WEBPACK FOOTER //
// ./src/components/hospital/commentInfo/GoodAtAreaTable.js